'use client';

import { useEffect } from 'react';
import useCurrentWalletAdapter from './useCurrentWalletAdapter';
import useCurrentWalletConnectionState from './useCurrentWalletConnectionState';
import { DriftWindow } from '../window/driftWindow';

interface Params {
	onConnectedCallback?: () => void;
	onDisconnectedCallback?: () => void;
}

const useWalletIsConnected = ({
	onConnectedCallback,
	onDisconnectedCallback,
}: Params = {}) => {
	const currentWallet = useCurrentWalletAdapter();
	const walletConnectionState = useCurrentWalletConnectionState();
	const walletIsConnected = Boolean(
		currentWallet?.publicKey &&
		currentWallet?.connected &&
		walletConnectionState.instance.FullyConnected
	);

	useEffect(() => {
		if (walletIsConnected) {
			DriftWindow.recordStartupTimeMetric('userFullyConnected');
			onConnectedCallback?.();
			return;
		}

		onDisconnectedCallback?.();
	}, [walletIsConnected]);

	return walletIsConnected;
};

/**
 * Used to check if the wallet adapter is connected.
 * Does not check if balances and subaccount subscriptions are loaded.
 */
export const useWalletAdapterIsConnected = () => {
	const walletConnectionState = useCurrentWalletConnectionState();

	return walletConnectionState.instance.is('AdapterConnected');
};

export default useWalletIsConnected;
